import LayoutV2 from 'components/common/LayoutV2';
import MarketplaceIntro from 'components/community/gridV2/MarketplaceIntro';
import CommunityFeaturedView from 'components/community/gridV2/CommunityFeaturedView';

export default function CommunityPage() {
  return (
    <LayoutV2
      title="Marketplace"
      showCommunitySearch
      showCommunityFilters
      selectedCommunityFilter="featured"
    >
      <MarketplaceIntro
        eyebrow="Featured"
        title="Made with Rive"
        description="Hand-picked files from the community."
      />
      <CommunityFeaturedView />
    </LayoutV2>
  );
}
